import type { IDadataSuggestion } from '../../../services/dadataSuggest';

const POSTAL_CODE_REGEXP = /^\d{6}$/;

function normalizeValue(value: string | null | undefined): string {
  return value?.trim() ?? '';
}

export function hasHouse(suggestion: IDadataSuggestion | null): boolean {
  return Boolean(normalizeValue(suggestion?.data.house));
}

export function getDadataPostalCode(suggestion: IDadataSuggestion | null): string {
  return normalizeValue(suggestion?.data.postal_code);
}

export function needsManualPostalCode(suggestion: IDadataSuggestion | null): boolean {
  return hasHouse(suggestion) && !getDadataPostalCode(suggestion);
}

export function buildDeliveryAddress(selectedAddress: IDadataSuggestion | null, manualPostalCode: string): string {
  const address = normalizeValue(selectedAddress?.unrestricted_value);
  const manualPostalCodeValue = needsManualPostalCode(selectedAddress) ? manualPostalCode.trim() : '';
  const postalCode = getDadataPostalCode(selectedAddress) || manualPostalCodeValue;
  const addressAlreadyHasPostalCode = Boolean(postalCode) && address.startsWith(`${postalCode},`);

  return postalCode && !addressAlreadyHasPostalCode ? `${postalCode}, ${address}` : address;
}

export function validateSelectedAddress(
  selectedAddress: IDadataSuggestion | null,
  addressValue: string,
): true | string {
  const normalizedAddress = addressValue.trim();

  if (!normalizedAddress) {
    return 'Укажите адрес доставки';
  }

  if (!selectedAddress || normalizeValue(selectedAddress.unrestricted_value) !== normalizedAddress) {
    return 'Выберите адрес с домом из подсказки';
  }

  return hasHouse(selectedAddress) ? true : 'Укажите дом в адресе доставки';
}

export function validatePostalCode(selectedAddress: IDadataSuggestion | null, manualPostalCode: string): true | string {
  if (!needsManualPostalCode(selectedAddress)) {
    return true;
  }

  const normalizedPostalCode = manualPostalCode.trim();

  if (!normalizedPostalCode) {
    return 'Укажите индекс';
  }

  return POSTAL_CODE_REGEXP.test(normalizedPostalCode) ? true : 'Индекс состоит из 6 цифр';
}
